import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicAssetCancellationRequestCreateParamsRawI,
	LWApiPublicAssetCancellationRequestCreateResultRawI,
} from '@liquidweb-dev/club-sauce/public/asset/cancellation/request/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import useSnackbarError from 'utility/hooks/useSnackbarError';
import { SUPPORT_REQUEST_DETAILS_QUERY_KEY } from 'modules/queries/support/request/useDetails';
import { ASSET_CANCELLATION_REQUEST_DETAILS_QUERY_KEY } from './useRequestDetails';

const useAssetCancellationRequestCreate = () => {
	const queryClient = useQueryClient();
	const snackbarError = useSnackbarError();

	return useMutation<
		LWApiPublicAssetCancellationRequestCreateResultRawI,
		ApiErrorI,
		LWApiPublicAssetCancellationRequestCreateParamsRawI
	>({
		mutationFn: (params) =>
			api.asset.cancellation.request.apiRaw.create(params),
		onSuccess: (data, params) => {
			queryClient.invalidateQueries({
				queryKey: [
					ASSET_CANCELLATION_REQUEST_DETAILS_QUERY_KEY,
					{ uniq_id: params.uniq_id },
				],
			});
			queryClient.invalidateQueries({
				queryKey: [
					SUPPORT_REQUEST_DETAILS_QUERY_KEY,
					{ ticket_number: data.cancellation_ticket },
				],
			});
		},
		onError: snackbarError,
	});
};

export default useAssetCancellationRequestCreate;
